import { useAccounts } from '../../../fetchHooks/useAccount';
import type { Account } from '../../../generated-types';
import { isValidAccountTransferFrom, isValidAccountTransferTo } from '../../../services/accountFilters';

export enum CanTransferMoney {
    NO,
    YES,
    PROCESSING,
    ERROR,
}

export const canTransferBetweenAccounts = (accounts: Account[]): CanTransferMoney => {
    const transferFrom = accounts.filter(isValidAccountTransferFrom);
    const transferTo = accounts.filter(isValidAccountTransferTo);

    if (!transferFrom.length || !transferTo.length) return CanTransferMoney.NO;

    const canTransferMoney = !(
        transferFrom.length === 1 &&
        transferTo.length === 1 &&
        transferFrom[0].accountId === transferTo[0].accountId
    );
    return canTransferMoney ? CanTransferMoney.YES : CanTransferMoney.NO;
};

const useCanTransferMoney = (): CanTransferMoney => {
    const { data: accounts, isLoading, isError } = useAccounts();

    if (isLoading) return CanTransferMoney.PROCESSING;
    if (isError) return CanTransferMoney.ERROR;
    return canTransferBetweenAccounts(accounts ?? []);
};

export default useCanTransferMoney;
